__turbopack_context__.v({
  "card": "integrations-visual-module__WVvtDa__card",
  "cardActive": "integrations-visual-module__WVvtDa__cardActive",
  "chat": "integrations-visual-module__WVvtDa__chat",
  "chatVisible": "integrations-visual-module__WVvtDa__chatVisible",
  "dot": "integrations-visual-module__WVvtDa__dot",
  "dotActive": "integrations-visual-module__WVvtDa__dotActive",
  "key": "integrations-visual-module__WVvtDa__key",
  "keyCopy": "integrations-visual-module__WVvtDa__keyCopy",
  "keyLabel": "integrations-visual-module__WVvtDa__keyLabel",
  "keyRow": "integrations-visual-module__WVvtDa__keyRow",
  "keyRowOn": "integrations-visual-module__WVvtDa__keyRowOn",
  "status": "integrations-visual-module__WVvtDa__status",
  "statusActive": "integrations-visual-module__WVvtDa__statusActive",
});
